import React, { useState } from 'react'

import cx from 'classnames'

import { Icon } from '@driftt/tide-icons'

import utilityStyles from '../../styles/utility.module.css'
import styles from './styles.module.css'

interface Props {
  onClick: (e: React.MouseEvent) => void
  className?: string
  children: React.ReactElement
}

const FilterTag: React.FC<Props> = ({ onClick, className, children, ...rest }) => {
  const [isHovered, setIsHovered] = useState(false)
  return (
    <button
      className={cx(
        styles.filterTagButton,
        utilityStyles.regularWeight,
        { [styles.filterTagButtonHovered]: isHovered },
        className
      )}
      {...rest}>
      {children}
      <div
        onMouseEnter={() => setIsHovered(true)}
        onMouseLeave={() => setIsHovered(false)}
        onClick={onClick}>
        <Icon className={styles.closeIcon} name="close" height={7.5} width={7.5} />
      </div>
    </button>
  )
}

export default FilterTag
